import React, { Component } from 'react'
import { connect } from 'react-redux'

// Styles
import './assignbox.scss'

// import components
import Header from '../../../shared/components/Header'
import HelpText from '../../../shared/components/HelpText'
import CloseButton from '../../../shared/elements/closeButton'
import Icon from '../../../shared/elements/icon'
import { AssignmentIcons } from '../../../shared/elements/icons'

// Actions
import { getUserAssignments, setEmployees } from '../../../actions/assign'

// Utils
import { translation } from '../../../utils/helpers'
import { hasSubscriptionPermission } from '../../../utils/auth'

class AssignBox extends Component {

  constructor (props) {
    super(props)
    this.state = {
      employees: []
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.renderEmployee = this.renderEmployee.bind(this)
    this.headerLeft = this.headerLeft.bind(this)
  }

  componentDidMount () {
    this.getAssignEmployees()
  }

  componentWillUnmount () {
    this.props.setEmployees([])
  }

  getAssignEmployees () {
    this.props.getUserAssignments(0).then((res) => {
      this.setState({
        employees: res.data.UserAssignments
      })
    }, () => {
      console.log('Getting assigned users failed')
    })
  }

  headerButtonsRight () {
    const onClick = () => {
      if (typeof this.props.closeAssign === 'function') {
        this.props.closeAssign()
      }
    }

    return <CloseButton onClick={onClick} ariaText={translation('235')} ariaPos={this.props.ariaPos} />
  }

  isEmployeeActive (employeeId) {
    let found = false
    this.props.activeEmployees.map((val) => {
      if (val === employeeId) {
        found = true
      }
    })
    return found
  }

  onEmployeeClick (employee) {
    let isActive = this.isEmployeeActive(employee.UserId)
    let activeEmployees = []
    if (!isActive) {
      // activeEmployees = [...this.props.activeEmployees]
      activeEmployees.push(employee.UserId)
    } else {
      activeEmployees = [...this.props.activeEmployees].filter((val) => {
        return val !== employee.UserId
      })
    }
    this.props.setEmployees(activeEmployees)
    this.props.onEmployeeChange(activeEmployees)
  }

  renderEmployee (employee, key) {
    let extraClass = ''
    let activeColor = 'Black'
    // Active class
    if (this.isEmployeeActive(employee.UserId)) {
      extraClass = 'active'
      activeColor = 'White'
    }
    let employeeHeigth = '136'
    if (this.props.auth.departmentType === 1) employeeHeigth = '65'
    const renderEmployeeTime = () => {
      let employeeTime = ''
      if (this.props.auth.departmentType !== 1) {
        employeeTime = [
          <div className='hint--top-right' aria-label={translation('2252')}>{employee.RemainingWorkTime}</div>,
          <div className='overTime hint--top-right' aria-label={translation('455')}>{(employee.OverTime || '00:00')}</div>,
          <div className='extraWork hint--top-right' aria-label={translation('2253')}>{employee.ExtraWorkTime}</div>,
          <div className='tasks hint--top-right' aria-label={translation('233')}><img src={'/images/icons/Task_16x16-' + activeColor + '.png'} />{employee.OtherWorkCount}</div>
        ]
      } else {
        employeeTime = (<div className='hint--top-right' aria-label={translation('2252')}>{employee.TotalTime}</div>)
      }
      return (
        <div>
          {hasSubscriptionPermission(this.props.auth, 20) && employeeTime}
        </div>
      )
    }

    return (
      <div key={key} className={'employee ' + extraClass} style={{height: employeeHeigth + 'px'}} onClick={this.onEmployeeClick.bind(this, employee)}>
        <div className={'initials hint--' + this.props.assignAriaPos} aria-label={employee.Name}>
          <img src={'/images/icons/Ring-' + activeColor + '.png'} />
          <span>{employee.UserInitials}</span>
        </div>
        {renderEmployeeTime()}
      </div>
    )
  }

  // <div className='hint--top-right' aria-label={translation('2252')}>{employee.RemainingWorkTime}</div>
  // <div className='overTime hint--top-right' aria-label={translation('455')}>+{employee.OverTime || '00:00'}</div>
  // <div className='extraWork hint--top-right' aria-label={translation('2253')}>+{employee.ExtraWorkTime}</div>
  // <div className='tasks hint--top-right' aria-label={translation('233')}><img src={'/images/icons/Task_16x16-' + activeColor + '.png'} />+{employee.OtherWorkCount}</div>

  headerLeft () {
    return (
      <HelpText text={translation('2338')} right white />
    )
  }

  render () {
    let width = this.state.employees.length * 60 + 'px'
    let assignBoxHeight = '186'
    if (this.props.auth.departmentType === 1) assignBoxHeight = '115'
    if (!hasSubscriptionPermission(this.props.auth, 20)) assignBoxHeight = '100'

    return (
      <div className='assignUserBox' style={{height: assignBoxHeight + 'px'}}>
        {!this.props.hideHeader && <Header router={this.props.router} title={translation('1856')} renderLeftBefore={() => <Icon style={{top: '8px', 'margin-right': '8px'}} size='m' icon={AssignmentIcons.Assign_Employee_Black} />} renderRight={this.headerButtonsRight} />}
        <div className='assignEmployeesOuter'>
          {this.props.hideHeader && <div className='inside-close-button'>{this.headerButtonsRight()}</div>}
          <div className='assignEmployees' style={{width: width}}>
            {this.state.employees.map(this.renderEmployee)}
          </div>
        </div>
      </div>
    )
  }

}

AssignBox.defaultProps = {
  assignAriaPos: 'right'
}
function mapStateToProps (state) {
  return {
    auth: state.auth,
    activeEmployees: state.assign.activeEmployees
  }
}

export default connect(mapStateToProps, {
  getUserAssignments,
  setEmployees
}, null, { withRef: true })(AssignBox)



// WEBPACK FOOTER //
// ./src/app/pages/NewWorkscreen/AssignBox/index.js